'use client'

import dynamic from 'next/dynamic'
import { type ReactNode, useEffect, useRef, useState } from 'react'

const KnockAi = dynamic(
	() => import('@/components/elementary/KnockAi').then((comp) => comp.KnockAi),
	{
		ssr: false,
	},
)

const KNOCK_AI_INTERSECTION_ROOT_MARGIN = '200px'

export function KnockAiLazy({
	dataId,
	skeleton,
	rootMargin = KNOCK_AI_INTERSECTION_ROOT_MARGIN,
}: {
	dataId: string
	rootMargin?: string
	skeleton?: ReactNode
}) {
	const wrapperRef = useRef<HTMLDivElement | null>(null)
	const [shouldLoad, setShouldLoad] = useState(false)

	useEffect(() => {
		if (shouldLoad) return
		const el = wrapperRef.current
		if (!el || typeof IntersectionObserver === 'undefined') {
			// Fallback: load immediately if IO not supported
			setShouldLoad(true)
			return
		}

		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0]
				if (entry?.isIntersecting) {
					setShouldLoad(true)
					observer.disconnect()
				}
			},
			{ root: null, rootMargin, threshold: 0 },
		)

		observer.observe(el)
		return () => observer.disconnect()
	}, [shouldLoad, rootMargin])

	return (
		<div ref={wrapperRef}>
			{shouldLoad ? <KnockAi dataId={dataId} skeleton={skeleton} /> : null}
		</div>
	)
}
